import { render } from "./App.vue?vue&type=template&id=12ac0f6e"
const script = {}

import "./App.vue?vue&type=style&index=0&id=12ac0f6e&lang=css"
script.render = render

export default script